import { OWN_GROUP_METRICS } from './useWatchlistOwnGroupPreferences';

export const metricPreference = (value) => Object.fromEntries(
    OWN_GROUP_METRICS.map(({ id }) => [id, value?.[id] === true]),
);

export function attributeDraftOperations(baseRows, rows) {
    const baseById = new Map(baseRows.map((row) => [row.attribute_definition_id, row]));
    const remaining = new Set(rows.map((row) => row.attribute_definition_id));
    const operations = baseRows.filter((row) => !remaining.has(row.attribute_definition_id))
        .map((row) => ({ op: 'retire', attribute_definition_id: row.attribute_definition_id }));
    for (const row of rows) {
        const base = baseById.get(row.attribute_definition_id);
        if (base && row.display_name.trim() !== base.display_name) operations.push({
            op: 'rename', attribute_definition_id: row.attribute_definition_id, display_name: row.display_name.trim(),
        });
    }
    const existingIds = rows.filter((row) => baseById.has(row.attribute_definition_id))
        .map((row) => row.attribute_definition_id);
    const originalIds = baseRows.filter((row) => remaining.has(row.attribute_definition_id))
        .map((row) => row.attribute_definition_id);
    if (existingIds.some((id, index) => id !== originalIds[index])) operations.push({
        op: 'reorder', attribute_definition_ids: existingIds,
    });
    rows.forEach((row, index) => {
        if (!baseById.has(row.attribute_definition_id)) operations.push({
            op: 'create', display_name: row.display_name.trim(), display_order: index,
        });
    });
    return operations;
}

export function attributeDraftValidation(rows) {
    if (rows.length > 20) return 'A Watchlist can have at most 20 attribute columns.';
    const names = rows.map((row) => row.display_name.trim());
    if (names.some((name) => !name)) return 'Give every attribute a name before saving.';
    if (names.some((name) => name.length > 80)) return 'Attribute names can have at most 80 characters.';
    if (new Set(names.map((name) => name.toLowerCase())).size !== names.length) {
        return 'Attribute names must be unique.';
    }
    return '';
}

export function changedAttributePreferences(baseRows, rows, basePreferences, preferences) {
    const remaining = new Set(rows.map((row) => row.attribute_definition_id));
    return baseRows.flatMap(({ attribute_definition_id: id }) => {
        if (!remaining.has(id)) return [];
        const next = metricPreference(preferences[id]);
        return JSON.stringify(next) === JSON.stringify(metricPreference(basePreferences[id])) ? [] : [[id, next]];
    });
}
